import React, { useContext } from 'react';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { pxToRem } from "../../../common";
import { TourContext } from "../context";
import { styled } from '@mui/material/styles';
var StyledTourHead = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.palette.tour.header.background,
    padding: '8px 8px 16px 16px'
  };
});
var StyledTourTitle = styled('div')(function () {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    minWidth: '145px'
  };
});
var StyledTourProgress = styled(LinearProgress)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    height: '14px',
    minWidth: '100px',
    width: '60%',
    '&, .MuiLinearProgress-bar': {
      borderRadius: '6px 6px 6px 6px'
    },
    backgroundColor: theme.palette.tour.progress.background,
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.tour.progress.bar
    }
  };
});
export function TourHeader(_ref3) {
  var _ref3$completedCount = _ref3.completedCount,
    completedCount = _ref3$completedCount === void 0 ? 0 : _ref3$completedCount,
    _ref3$totalFeatures = _ref3.totalFeatures,
    totalFeatures = _ref3$totalFeatures === void 0 ? 0 : _ref3$totalFeatures,
    onTourToggle = _ref3.onTourToggle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(TourContext),
    isTourExpanded = _useContext.isTourExpanded,
    setIsTourExpanded = _useContext.setIsTourExpanded;
  var currentProgress = completedCount / totalFeatures * 100;
  function toggleTourExpanded() {
    setIsTourExpanded(!isTourExpanded);
    if (onTourToggle) {
      onTourToggle(!isTourExpanded);
    }
  }
  return /*#__PURE__*/React.createElement(StyledTourHead, {
    sx: {
      borderRadius: isTourExpanded ? '12px 12px 0 0' : 'inherit'
    }
  }, /*#__PURE__*/React.createElement(StyledTourTitle, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    component: "div",
    sx: {
      color: 'white',
      fontSize: pxToRem(13),
      fontWeight: 700
    }
  }, t('tour_header_title')), /*#__PURE__*/React.createElement(Button, {
    disableRipple: true,
    variant: "text",
    size: "small",
    onClick: function onClick() {
      return toggleTourExpanded();
    },
    sx: {
      color: 'white',
      p: 0,
      minWidth: 'min-content'
    }
  }, isTourExpanded ? /*#__PURE__*/React.createElement(ExpandMore, null) : /*#__PURE__*/React.createElement(ExpandLess, null))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '4px',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(StyledTourProgress, {
    variant: "determinate",
    value: currentProgress
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "span",
    sx: {
      color: 'tour.progress.text',
      fontSize: '12px',
      weight: 400
    }
  }, "".concat(completedCount, "/").concat(totalFeatures))));
}